import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import _ from "lodash";

export const selectArticlegroupsMap = createSelector(
  [(state: RootState) => state.menuData.menukaarts],
  (articlegroups) => _.keyBy(articlegroups, "id")
);
